import React from 'react';
import {Outlet} from 'react-router-dom';
import styles from './RegistrationLayout.module.css';

export function RegistrationLayout(): React.ReactElement {
	return (
		<div className={styles.root}>
			<main className={styles.main} data-registration-scroll>
				<Outlet />
			</main>
		</div>
	);
}
